module.exports = __webpack_public_path__ + "/images/ico-color-gratis-it.db61cc4.svg";